import React from 'react';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core';
import { HelpOutline } from '@material-ui/icons';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';

const styles = theme => ({
    section: {
        position: 'relative',
    },
    sectionIcon: {
        padding: '0 0 0 40px',
    },
    title: {
        fontSize: '14pt',
        marginBottom: theme.spacing(),
    },
    header: {},
    help: {},
    body: {},
    headerIcon: {
        position: 'absolute',
        top: 0,
        left: '-4px',
        color: theme.palette.text.secondary,
    },
    headerIconAlone: {
        top: 16,
        left: 0,
    },

    helpIcon: {
        fontSize: '18pt',
        padding: '2px',
        verticalAlign: 'middle',
        margin: '0 0 0 8px',
        color: theme.palette.text.secondary,
    },
});

const SectionForm = ({ classes, title, help, icon, half, children }) => {
    const IconComponent = icon;
    const helpIcon = help && (
        <Tooltip title={help}>
            <HelpOutline className={classes.helpIcon} />
        </Tooltip>
    );
    const width = half ? '50%' : '100%';
    const iconClassName = classNames(classes.headerIcon, {
        [classes.headerIconAlone]: !title,
    });
    const sectionClassName = classNames(classes.section, {
        [classes.sectionIcon]: icon,
    });
    return (
        <div className={sectionClassName} style={{ width }}>
            <div className={classes.header}>
                {icon && <IconComponent className={iconClassName} />}
                {title && (
                    <Typography component="div" className={classes.title}>
                        {title}
                        {helpIcon}
                    </Typography>
                )}
            </div>
            <div className={classes.body}>{children}</div>
        </div>
    );
};

export default withStyles(styles)(SectionForm);
